import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId } from "commons/types/api/common";

import {
    SectionOneImageFiveTextsBody,
    SectionOneImageFiveTextsDetails,
} from "types/api/blocks/sectionOneImageFiveTexts";

function useSectionOneImageFiveTextsApi() {
    const { get, del, post } = useHttpManaged();
    const getOneSectionOneImageFiveTexts = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<SectionOneImageFiveTextsDetails> => {
        return get<PathParamsWithId, undefined, SectionOneImageFiveTextsDetails>({
            url: "/blocks/section-one-image-five-texts/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const saveSectionOneImageFiveTexts = React.useCallback((body: SectionOneImageFiveTextsBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return post<undefined, undefined, SectionOneImageFiveTextsBody, null>({
            url: "/blocks/section-one-image-five-texts",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const deleteSectionOneImageFiveTexts = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/blocks/section-one-image-five-texts/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getOneSectionOneImageFiveTexts,
        saveSectionOneImageFiveTexts,
        deleteSectionOneImageFiveTexts
    };
}

export default useSectionOneImageFiveTextsApi;